const getLevelProgress = (total, min, max) => {
	if (total <= min) return 0
	if (total >= max) return 1
	return (total - min) / (max - min)
}

export { getLevelProgress }
